import type CartPaymentInfo from "~/domains/payment/cart/CartPaymentInfo";
import type CartServiceInfo from "~/domains/payment/cart/CartServiceInfo";
import type DiscountInfo from "../../DiscountInfo";
import type { DiscountInfoType } from "../../DiscountInfoType";
import type ServiceDiscountStrategy from "./ServiceDiscountStrategy";
import { getNdcDiscountDescription, roundPrice } from "~/utils/payment";

export default class NdcFreeServiceServiceDiscountStrategy implements ServiceDiscountStrategy {
  getDiscountInfoType(): DiscountInfoType {
    return "ndcFreeService";
  }

  getDiscountInfo(cartServiceInfo: CartServiceInfo, cartPaymentInfo: CartPaymentInfo): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "ndcFreeService",
      description: "",
      value: 0,
      amount: 0,
    };

    const ndcInfo = cartPaymentInfo.ndc;

    /* Free Round only applies if:
      - Has the prerequisite service in their cart.
      - Has the extra service in their cart.
      - The extra service has the minimum number of rounds remaining in the season (default 1).
      - This service is a seasonal service.
    */
    if (
      ndcInfo?.pricingRule === "FreeService"
      && cartPaymentInfo.services.find((service) => service.ServiceDefId === ndcInfo?.product?.id)
      && cartServiceInfo.ServiceDefId === ndcInfo?.product?.extraService?.id
      && !cartServiceInfo.isMonthly
      && !cartServiceInfo.isInitialPayment
    ) {
      let minimumRequiredRoundsRemaining = 1;

      if (cartServiceInfo.remainingRounds >= minimumRequiredRoundsRemaining) {
        const discountValue = roundPrice(cartServiceInfo.mainPrice ?? 0, "nearest", 2);

        discountInfo.description = `${getNdcDiscountDescription(ndcInfo)} - ${cartServiceInfo.ServiceName}`;
        discountInfo.value = discountValue;
        discountInfo.amount = discountValue;
        discountInfo.serviceDefId = cartServiceInfo.ServiceDefId;
        discountInfo.freeRounds = 1;
      }
    }

    return discountInfo;
  }

  getMonthlyDiscountInfo(cartServiceInfo: CartServiceInfo, cartPaymentInfo: CartPaymentInfo): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "ndcFreeService",
      description: "",
      value: 0,
      amount: 0,
    };

    return discountInfo;
  }

  getInitialPaymentDiscountInfo(cartServiceInfo: CartServiceInfo, cartPaymentInfo: CartPaymentInfo): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "ndcFreeService",
      description: "",
      value: 0,
      amount: 0,
    };

    return discountInfo;
  }
}